export type UpgradeAlertData = {
  description: string;
  url?: string;
  typeformId?: string;
};

export const accountReceivableUpgradeAlert: UpgradeAlertData = {
  description: 'accountReceivable_onBoarding_informationBanner',
  typeformId: 'dXjyB9N1',
};

export const accountPayableUpgradeAlert: UpgradeAlertData = {
  description: 'accountPayable_onBoarding_informationBanner',
  typeformId: 'dXjyB9N1',
};

export const accountReceivableKYBUpgradeAlert: UpgradeAlertData = {
  description: 'accountReceivable_onBoarding_informationBanner',
  url: '/upgrade',
};

export const accountPayableKYBUpgradeAlert: UpgradeAlertData = {
  description: 'accountReceivable_onBoarding_informationBanner',
  url: '/upgrade',
};
